import React from "react";
import parse from "html-react-parser";
import PropTypes from "prop-types";

import "./dropdown.scss";
import { dropDown } from "../../assets/images/icons";

import DropdownItem from "../DropdownItem/dropdownItem";

const {
  CLASSES: { MODIFY_ELEMENT },
} = require("../../utils/constants");

const Dropdown = ({
  pages = [],
  activeUri = "",
  allPagesData = {},
}) => {
  const toggleListExpand = () => {
    document
      ?.getElementsByClassName("current-item")[0]
      ?.classList?.toggle(MODIFY_ELEMENT.HIDE);
    document
      ?.getElementsByClassName("dropdown")[0]
      ?.classList?.toggle(MODIFY_ELEMENT.HIDE);
  };

  return pages.length > 1 ? (
    <div className="dropdown-div">
      <div
        className="current-item"
        onClick={toggleListExpand}
      >
        <div className="dropdown-item">
          {allPagesData[activeUri]?.title}
        </div>
        <div className="dropdown-span">
          {parse(dropDown)}
        </div>
      </div>

      <div
        className={"dropdown " + MODIFY_ELEMENT.HIDE}
        onClick={toggleListExpand}
      >
        <ul className="dropdown-list">
          {pages?.map(uri => {
            return (
              <DropdownItem
                uri={uri}
                allPagesData={allPagesData}
                activeItem={uri === activeUri}
                key={uri}
              />
            );
          })}
        </ul>
      </div>
    </div>
  ) : (
    <input
      value={allPagesData[activeUri]?.title}
      className="input-div"
      readOnly
    />
  );
};

Dropdown.propTypes = {
  pages: PropTypes.array,
  activeUri: PropTypes.string,
  allPagesData: PropTypes.object,
};

export default Dropdown;
